import { TopTooltip } from 'ui/tooltip';
import { BUTTON_VARIANTS, BUTTON_SIZES, IconButton } from 'ui/button';
import { isDefined } from 'utils/tsHelpers';
import { ConditionActionButtonProps } from './types';

export const DATA_TEST = {
  button: 'queryBuilder-icon-button',
};

export const QueryBuilderIconButton = ({
  onClick,
  isDisabled,
  tooltipContent,
  Icon,
  dataTest = DATA_TEST.button,
  variant = BUTTON_VARIANTS.SECONDARY,
}: ConditionActionButtonProps) => {
  return (
    <TopTooltip
      tooltipContent={tooltipContent}
      isEnabled={isDefined(tooltipContent)}
      delayDuration={400}
      isUsedOnButton
    >
      <IconButton
        data-test={dataTest}
        onClick={onClick}
        isDisabled={isDisabled}
        variant={variant}
        size={BUTTON_SIZES.SMALL}
        type="button"
      >
        <Icon />
      </IconButton>
    </TopTooltip>
  );
};
